import { render } from "./rule.vue?vue&type=template&id=5303afd4&scoped=true"
import script from "./rule.vue?vue&type=script&lang=ts"
export * from "./rule.vue?vue&type=script&lang=ts"

import "./rule.vue?vue&type=style&index=0&id=5303afd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5303afd4"

export default script